export default __webpack_public_path__ + "static/media/TL01.2.b427bc0b.mp3";